import { cx } from "#ui/style.utils";

/**
 * Common class names used by all footer links/buttons.
 * Do not add layout or color specific styles here
 * as this is used in multiple footers.
 */
export const classNamesFooterLink = cx(
  "whitespace-nowrap",
  // radii (shapes focus outline)
  "rounded-sm",
  // focus/hover/active
  "hover:underline focus:underline active:underline",
  "hover:decoration-1 focus:decoration-1 active:decoration-1",
  // focus outline (keyboard only)
  "focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring-normal",
);
